// ตัวช่วยสร้างเหตุการณ์เฉพาะตัวของสัตว์ดัง (docs/PLAN.md เฟส 3: signature events)
// แต่ละเรื่องผูกกับชื่อวิทยาศาสตร์ เกิดได้ครั้งเดียวต่อชีวิต และมีน้ำหนักสูงกว่าเหตุการณ์ทั่วไป
// ชนิดที่ใช้ต้องมีในรายชื่อที่คัดไว้ (src/data/fauna.ts หรือ src/data/demo-species.ts) เพื่อให้ตัวจำลองเล่นทดสอบได้

import type { Choice, EventRequires, GameEvent, StageTag } from "../../engine/types";

export const SIGNATURE_WEIGHT = 8;
const ACTIVE: readonly StageTag[] = ["young", "adult", "old"];

interface Signature {
  stageTags?: readonly StageTag[];
  stages?: readonly string[];
  requires?: Omit<EventRequires, "species">;
  text: string;
  fact: string;
  choices: readonly Choice[];
}

/** เหตุการณ์เฉพาะของชนิด sci (id ขึ้นต้นด้วย sig_) */
export function sig(sci: string, id: string, e: Signature): GameEvent {
  return {
    id: `sig_${id}`,
    ...(e.stages ? { stages: e.stages } : { stageTags: e.stageTags ?? ACTIVE }),
    requires: { ...e.requires, species: [sci] },
    weight: SIGNATURE_WEIGHT,
    once: true,
    text: e.text,
    fact: e.fact,
    choices: e.choices,
  };
}
